let $button = document.querySelector('.header__toggle-button')
let $menu = document.querySelector('.menu')

$button.addEventListener('click',()=>{
    $button.classList.toggle('active')
    $menu.classList.toggle('active')
})